import { render } from "./LiveVideoAlert.vue?vue&type=template&id=9c1c59c0"
import script from "./LiveVideoAlert.vue?vue&type=script&lang=js"
export * from "./LiveVideoAlert.vue?vue&type=script&lang=js"
script.render = render

export default script